var PageRow = require('./pageRow/view'),
    BaseSearchRow = require('./searchRow/base'),
    SearchHierarchyRowWithNoChildren = require('./searchRow/searchRowWithPageLink');



/* Now not header and hit -- just page or search */


module.exports = function( node ) {

    if ( node.isPageNode() ) {
        return PageRow;
    }

    if ( node.isSearchNode() ) {

       if ( node.get('rowLevel') === 2 ) {

           return BaseSearchRow;

       } else {

           if ( node.hasMultipleChildren() ) {

               return BaseSearchRow;

           } else {

               return SearchHierarchyRowWithNoChildren;

           }

       }

    }

};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsTableView/bodyRows/rowFactory.js
 ** module id = 629
 ** module chunks = 0
 **/